import { render, staticRenderFns } from "./WorkspaceRemoveNodeConfirmModal.vue?vue&type=template&id=0e660d05&scoped=true"
import script from "./WorkspaceRemoveNodeConfirmModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceRemoveNodeConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceRemoveNodeConfirmModal.vue?vue&type=style&index=0&id=0e660d05&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e660d05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e660d05')) {
      api.createRecord('0e660d05', component.options)
    } else {
      api.reload('0e660d05', component.options)
    }
    module.hot.accept("./WorkspaceRemoveNodeConfirmModal.vue?vue&type=template&id=0e660d05&scoped=true", function () {
      api.rerender('0e660d05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceRemoveNodeConfirmModal.vue"
export default component.exports